// extracted by mini-css-extract-plugin
export default {"genericCard":"in-z","inline":"jn-z","mastercard":"kn-z","discover":"ln-z","visa":"mn-z","amex":"nn-z","active":"on-z"};